import { IBaseTheme } from '../../../common/types';

export const BaseTheme: IBaseTheme = {
  unitSize: 8,
  itemHeight: 40,
  itemCompactHeight: 32,
  itemSmallHeight: 24,
  borderRadius: 6,
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    laptop: '992px',
    desktop: '1200px',
  }
};
